module.exports = __webpack_public_path__ + "img/tap-to-pay.d6c40725.png";